import { Group } from '@mantine/core';

import CreateOrganizationForm from './CreateOrganizationForm';
import RevokeOrganizationAccess from './RevokeOrganizationAccess';
import useUserInfo from '../../hooks/useUserInfo';

const AdminPage: React.FC = () => {
  const { userHasGlobalPermission } = useUserInfo();
  const canCreateOrg = userHasGlobalPermission('app.add_organization');

  return (
    <Group gap={64} align='flex-start' p={16}>
      { canCreateOrg && <CreateOrganizationForm flex={1} /> }
      <RevokeOrganizationAccess flex={1} />
    </Group>
  );
};

export default AdminPage;
